"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitApply = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var employment_1 = require("../../model/employment");
var service_1 = require("../../../library/base/service");
var SubmitApply = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SubmitApply, _super);
    function SubmitApply() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '联奇云招聘提交申请';
        _this.code = '300433';
        _this.desc = '联奇云招聘提交申请';
        _this.requestParams = new employment_1.SubmitApplyRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SubmitApply;
}(service_1.BaseService));
exports.SubmitApply = SubmitApply;
//# sourceMappingURL=submitApply.js.map